import type { Flow } from '../types';
import { api, ApiError } from './apiClient';
import { normalizeFlow, normalizeFlowList } from './normalizers';

export const flowsService = {
  async list(): Promise<Flow[]> {
    const res = await api.get<{ flows: unknown[] }>('/flows');
    return normalizeFlowList(res.flows);
  },

  async get(id: string): Promise<Flow | undefined> {
    try {
      const res = await api.get<{ flow: unknown }>(`/flows/${encodeURIComponent(id)}`);
      return normalizeFlow(res.flow);
    } catch (err) {
      if (err instanceof ApiError && err.status === 404) return undefined;
      throw err;
    }
  },

  async save(flow: Flow): Promise<Flow> {
    const res = await api.post<{ flow: unknown }>('/flows', flow);
    return normalizeFlow(res.flow);
  },

  async remove(id: string): Promise<void> {
    await api.del(`/flows/${encodeURIComponent(id)}`);
  },
};
